"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.724 2.902C16.832 2.902 21 6.96 21 11.998s-4.165 9.098-9.273 9.1c-3.767 0-7.016-2.204-8.467-5.378a.7.7 0 1 1 1.273-.583c1.227 2.683 3.983 4.56 7.194 4.56 4.363 0 7.874-3.461 7.873-7.698 0-4.238-3.513-7.697-7.876-7.697A7.94 7.94 0 0 0 5.5 7.286h2.14a.7.7 0 1 1 0 1.4H3.7a.7.7 0 0 1-.7-.7V4.147a.7.7 0 1 1 1.4 0V6.42c1.741-2.2 4.437-3.517 7.324-3.518M12 6.444a.7.7 0 0 1 .7.7v4.524a1.7 1.7 0 0 1-.785 1.433l-3.15 2.011a.7.7 0 0 1-.753-1.18l3.15-2.01a.3.3 0 0 0 .138-.254V7.144a.7.7 0 0 1 .7-.7",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=HistoryIcon24.js.map